import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

// import CapacityBar from './capacity_bar'
import AlbumListItem from "./album_list_item";
import Loader from "../loader";
import ModalAlbumCreate from "./modal_album_create";
import ModalConfirm from "../modal/modal_confirm";
import ModalAlert from "../modal/modal_alert";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    circleId: PropTypes.number.isRequired,
    circleName: PropTypes.string,
    userId: PropTypes.number.isRequired,
    chargePlanType: PropTypes.number.isRequired,
    photoStrageLimit: PropTypes.number.isRequired,
    publicTypeData: PropTypes.object.isRequired,
    albumInitialTitle: PropTypes.string.isRequired,
    isCirclePrivate: PropTypes.bool.isRequired,
    myMemberType: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      allFileCapacity: 0,
      albums: {},
      // メンバー以外にだけ意味がある。サーバーは限定アルバムの中身を返さず、あるかどうかだけを返す
      hasRestrictedAlbums: false,
      loading: true,
      isAlbumCreatModalOpen: false,
      fadeClassName: "fade-in",
      isDeleteMode: false,
      scrollPos: 0,
      selectedAlbumId: 0,
    };
  },
  componentDidMount() {
    // this.loadAllFileCapacityFromServer();
    this.loadAlbumsFromServer();
  },
  changeDeleteMode() {
    this.setState({
      isDeleteMode: !this.state.isDeleteMode,
    });
  },
  openModal() {
    var scrollPos = $("body").scrollTop();
    var marginLeft =
      (window.innerWidth - $("body .container").outerWidth()) / 2;
    $("body").css({
      position: "fixed",
      marginTop: -scrollPos,
      marginLeft: marginLeft,
    });
    this.setState({
      isAlbumCreatModalOpen: true,
      fadeClassName: "fade-in",
      scrollPos: scrollPos,
    });
  },
  closeModal() {
    $("body").css({ position: "relative", marginTop: "0", marginLeft: "0" });
    $("body").scrollTop(this.state.scrollPos);
    this.setState({
      fadeClassName: "fade-out",
    });
    setTimeout(
      function() {
        this.setState({
          isAlbumCreatModalOpen: false,
        });
      }.bind(this),
      300
    );
  },
  loadAllFileCapacityFromServer() {
    // // 有料プランの場合はファイル容量を取得しない
    // if (this.props.chargePlanType != 0) {
    //   return;
    // }
    // $.ajax({
    //   url: '/api/album/get_all_file_capacity',
    //   type : 'POST',
    //   data: {
    //     circle_id: this.props.circleId
    //   },
    //   cache: false,
    //   success: function(data) {
    //     var capacity = Number(data);
    //     this.setState({
    //       allFileCapacity: capacity
    //     });
    //     // 値を取得できなかった場合の対応
    //   }.bind(this),
    //   error: function(xhr, status, err) {
    //     // ネットワークエラー対応
    //   }.bind(this)
    // });
  },
  loadAlbumsFromServer() {
    $.ajax({
      url: "/api/album/load_albums",
      type: "POST",
      data: {
        circle_id: this.props.circleId,
      },
      cache: false,
      success: function(data) {
        this.setState({
          albums: data.albums || {},
          hasRestrictedAlbums: !!data.has_restricted_albums,
          loading: false,
        });
      }.bind(this),
      error: function() {
        // 読み込み中のまま止まらないよう、失敗を伝えてローダーを消す
        this.setState({ loading: false }, this.showNetworkError);
      }.bind(this),
    });
  },
  deleteAlbumFromServer() {
    $.ajax({
      url: "/api/album/delete_album",
      type: "POST",
      dataType: "json",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        album_id: this.state.selectedAlbumId,
      },
      cache: false,
      success: function(data) {
        if (data) {
          this.loadAlbumsFromServer();
          this.loadAllFileCapacityFromServer();
        } else {
          this.modalAlertError.openModal();
        }
      }.bind(this),
      error: function() {
        this.modalAlertNetworkError.openModal();
      }.bind(this),
    });
  },
  deleteAlbum() {
    this.deleteAlbumFromServer();
  },
  albumSelected(e) {
    this.setState({
      selectedAlbumId: e,
    });
    this.modalConfirmDelete.openModal();
  },
  showAlbumCreateError() {
    this.modalAlertAlbumCreateError.openModal();
  },
  showNetworkError() {
    this.modalAlertNetworkError.openModal();
  },
  showPublicSettingError() {
    this.modalAlertPublicSettingError.openModal();
  },
  showStrageError() {
    this.modalAlertStrageError.openModal();
  },
  render() {
    // var capacityBar = '';
    // if (this.props.chargePlanType == 0) {
    //   capacityBar = <CapacityBar
    //     photoStrageLimit = {this.props.photoStrageLimit}
    //     allFileCapacity = {this.state.allFileCapacity}
    //   />;
    // }
    var albumListItems = [];
    // メンバー以外に見せるアルバムの絞り込みは、サーバー（load_albums）が行う
    Object.keys(this.state.albums).forEach(function(key) {
      albumListItems.unshift(
        <AlbumListItem
          key={key}
          albumId={Number(key)}
          circleId={this.props.circleId}
          album={this.state.albums[key]}
          publicTypeData={this.props.publicTypeData}
          isDeleteMode={this.state.isDeleteMode}
          isMember={this.props.myMemberType === 1}
          loadAlbumsFromServer={this.loadAlbumsFromServer}
          loadAllFileCapacityFromServer={this.loadAllFileCapacityFromServer}
          albumSelected={this.albumSelected}
        />
      );
    }, this);
    // 見出し（承認ずみのサークルのイベント一覧・画面68と同じ作り。サークル名を上に小さく）
    var circleName = this.props.circleName;
    var albumHead = function(action) {
      return (
        <div className="alb-head">
          <div className="alb-head__row">
            <h1 className="alb-head__title">
              {circleName ? (
                <span className="alb-head__circle">{circleName}</span>
              ) : (
                ""
              )}
              アルバム
            </h1>
            {action}
          </div>
        </div>
      );
    };
    if (this.state.loading) {
      return (
        <div className="album container overflow-hidden">
          {/* {capacityBar} */}
          {albumHead("")}
          <Loader isActive={this.state.loading} />
        </div>
      );
    }
    // アルバムが0冊のときの表示（見た目のみ）
    var isAlbumEmpty = albumListItems.length === 0;
    // メンバー以外には見えない「サークル内限定」のアルバムがあるか（表示の出し分けにだけ使う）
    var hasRestrictedAlbums = this.state.hasRestrictedAlbums;
    var isJoinRequesting = this.props.myMemberType === 3;
    // メンバーになると見られるアルバムがあるときは、サークルページ（加入の操作がある）へ誘う
    var isJoinInvite = isAlbumEmpty && hasRestrictedAlbums && !isJoinRequesting;
    let initialPublicType = this.props.isCirclePrivate ? 2 : 4;
    return (
      <div className="album container overflow-hidden">
        <ModalAlbumCreate
          isOpen={this.state.isAlbumCreatModalOpen}
          closeModal={this.closeModal}
          fadeClassName={this.state.fadeClassName}
          publicTypeData={this.props.publicTypeData}
          initialTitle={this.props.albumInitialTitle}
          initialPublicType={initialPublicType}
          circleId={this.props.circleId}
          userId={this.props.userId}
          allFileCapacity={this.state.allFileCapacity}
          photoStrageLimit={this.props.photoStrageLimit}
          chargePlanType={this.props.chargePlanType}
          isCirclePrivate={this.props.isCirclePrivate}
          showAlbumCreateError={this.showAlbumCreateError}
          showNetworkError={this.showNetworkError}
          showPublicSettingError={this.showPublicSettingError}
          showStrageError={this.showStrageError}
        />
        {/* {capacityBar} */}
        {albumHead("")}

        {isAlbumEmpty ? (
          <div className="alb-list-empty">
            {/* やることリスト（画面36）の0件表示と同じ、グレーの丸に線のアイコン */}
            <span className="alb-list-empty__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <path d="m21 15-5-5L5 21" />
              </svg>
            </span>
            {this.props.myMemberType === 1 ? (
              <React.Fragment>
                <p className="alb-list-empty__title">
                  このサークルのアルバムはありません
                </p>
                <p className="alb-list-empty__text">
                  アルバムを作って、思い出を共有しよう！
                </p>
                <button
                  type="button"
                  className="alb-create"
                  onClick={this.openModal}
                >
                  アルバムを作成する
                </button>
              </React.Fragment>
            ) : hasRestrictedAlbums ? (
              <React.Fragment>
                <p className="alb-list-empty__title">
                  メンバー限定のアルバムがあります
                </p>
                <p className="alb-list-empty__text">
                  {isJoinRequesting
                    ? "加入が承認されると、見られるようになります。"
                    : "このアルバムはサークルメンバーのみ閲覧できます。"}
                </p>
                {isJoinInvite ? (
                  <a
                    className="alb-create"
                    href={"/circle/" + this.props.circleId}
                  >
                    サークルページでメンバーになる
                  </a>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <p className="alb-list-empty__title">
                  このサークルのアルバムはありません
                </p>
                <p className="alb-list-empty__text">
                  新しいアルバムが公開されると、ここに表示されます。
                </p>
              </React.Fragment>
            )}
          </div>
        ) : (
          <React.Fragment>
            <ul className="alb-grid">
              {/* アルバムを作成する。以前の「新規作成」と同じく一覧の先頭（左上）に固定 */}
              {this.props.myMemberType === 1 ? (
                <li className="alb-card alb-card--new">
                  <button
                    type="button"
                    className="alb-card__newbtn"
                    onClick={this.openModal}
                  >
                    <span className="alb-card__plus" aria-hidden="true">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
                    </span>
                    <span className="alb-card__newlabel">アルバムを作成する</span>
                  </button>
                </li>
              ) : (
                ""
              )}
              {albumListItems}
            </ul>
          </React.Fragment>
        )}
        <ModalConfirm
          ref={(c) => {
            this.modalConfirmDelete = c;
          }}
          title="アルバムの削除"
          content="元に戻すことはできません。よろしいですか？"
          approveFunc={this.deleteAlbum}
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertError = c;
          }}
          title="エラー"
          content="アルバムの削除に失敗しました。時間を置いてもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertNetworkError = c;
          }}
          title="エラー"
          content="ネットワークエラーが発生しました。ネットワークの接続を確認し、もう一度試してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertAlbumCreateError = c;
          }}
          title="エラー"
          content="アルバムの作成に失敗しました。後でもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertPublicSettingError = c;
          }}
          title="公開範囲"
          content="サークルの公開設定が「非公開」なので、公開範囲を「サークルメンバー」でアルバムを保存することができません。サークルの公開設定を「公開」にするか、アルバムの公開範囲を「サークルメンバー」に設定してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertStrageError = c;
          }}
          title="容量制限"
          content="プライベートストレージの制限を超えているので、公開範囲を「サークルメンバー」でアルバムを保存することができません。アルバムの公開範囲を「公開」に設定するか、他の画像を削除してください。また、有料プランに加入するとプライベートストレージの制限を解除できます。"
        />
        {isJoinInvite ? (
          ""
        ) : (
          <p className="alb-back">
            <a href={"/circle/" + this.props.circleId}>サークルページに戻る</a>
          </p>
        )}
      </div>
    );
  },
});
